import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnderline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.5 2.75a.75.75 0 0 1 .75.75v5.83a3.5 3.5 0 0 0 7 0V3.5a.75.75 0 0 1 1.5 0v5.83a5 5 0 1 1-10 0V3.5a.75.75 0 0 1 .75-.75M3.75 16.5a.75.75 0 0 1 .75-.75h11a.75.75 0 1 1 0 1.5h-11a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUnderline;
